import { Divider } from "antd";
import { FC } from "react";
import { AppPartType } from "../../../types";
import { COLUMN_WIDTH } from "@lhd/features/Apps/AppForm/constants";

type Prop = {
  appPart: AppPartType;
};
const Border: FC<Prop> = ({ appPart }) => {
  const level_border = appPart?.item_config_data?.level_horizontal || 0;
  const height_x = COLUMN_WIDTH * level_border || 1;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: height_x,
        margin: "0 auto",
      }}
    >
      <div
        style={{
          height: height_x,
          background: "rgba(0, 0, 0, 0.5)",
          width: "100%",
        }}
      ></div>
    </div>
  );
};

export default Border;
